import type { Product } from '../types/product';

export const getInviteProducts = ({
	product,
	canInviteToJiraSoftware,
	canInviteToConfluence,
}: {
	product?: string;
	canInviteToJiraSoftware: boolean;
	canInviteToConfluence: boolean;
}): Product[] => {
	const inviteProducts: Product[] = [];

	if (canInviteToJiraSoftware) {
		inviteProducts.push('jira-software');
	}

	if ((product === 'atlas' || !product) && canInviteToConfluence) {
		inviteProducts.push('confluence');
	}

	return inviteProducts;
};
